/**
 * Historia 176 — CU7, T8 (S124, `03-dominio.md` §6.1). Formats an ISO-8601 UTC instant (Sun's
 * `TermChangeDto.changedAt`) as `dd/MM/yyyy HH:mm`, in the LOCAL time zone of whoever runs this
 * code (the browser in production; `process.env.TZ` in tests, DG2-0). No i18n: the digit order is
 * fixed by the contract, not by the active language.
 *
 * @param {string} isoString ISO-8601 UTC instant, e.g. `2026-09-28T12:00:00Z`
 * @returns {string} `dd/MM/yyyy HH:mm` in local time
 */
export const formatLocalDateTime = (isoString) => {
  const date = new Date(isoString)
  const pad = (value) => String(value).padStart(2, '0')
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}
